// Single source of truth for plan limits + capabilities.
// caps: numbers; -1 means unlimited. can: capability booleans.
export const PLAN_KEYS = { free: 'free', pro: 'pro', max: 'max' };

export const PLAN_MATRIX = {
    free: {
        caps: { diagrams: 4, members: 4, tables: 40, columns: 20, notes: 20, pens: 100, areas: 10 },
        // free CAN collaborate + share (changed from the old canCollaborate:false);
        // only promoting collaborators to non-member roles (admin_roles) is Pro.
        can: { collaborate: true, shareDiagrams: true, admin_roles: false },
    },
    pro: {
        caps: { diagrams: -1, members: -1, tables: -1, columns: -1, notes: -1, pens: -1, areas: -1 },
        can: { collaborate: true, shareDiagrams: true, admin_roles: true },
    },
};
// `max` aliases `pro` (same object reference, intentional) until its real
// definition lands. Treat PLAN_MATRIX entries as read-only config.
PLAN_MATRIX.max = PLAN_MATRIX.pro;

export function getPlan(slug) {
    return PLAN_MATRIX[(slug || 'free').toLowerCase()] || PLAN_MATRIX.free;
}

// Back-compat alias: sagas still call getPlanRestrictions(slug) and store the
// result as workspace.restrictions. It now returns the matrix entry { caps, can }.
export const getPlanRestrictions = getPlan;
